// extracted by mini-css-extract-plugin
export default {"root":"Spacing-module--root--55eb5","subtitle":"Spacing-module--subtitle--4648a","defaultTiny":"Spacing-module--defaultTiny--c44d5"};